import React from 'react';

import { HiddenInput, Slider, ToggleContainer } from './toggle.styled';
import { IToggle } from './types';

const Toggle: React.FC<IToggle> = ({ checked, disabled = false, ...props }) => (
  <ToggleContainer checked={checked} disabled={disabled}>
    <HiddenInput
      type="checkbox"
      role="button"
      aria-pressed={checked}
      disabled={disabled}
      checked={checked}
      {...props}
    />
    <Slider />
  </ToggleContainer>
);

export default Toggle;
